'use client';

export default function coreImageLoader({src, width, quality}) {
    return src;
    // const isSslHttp = src.startsWith('http') || src.startsWith('https');
    // const cdnUrl = process.env.CDN_DOMAIN ? `https://${process.env.CDN_DOMAIN}` : 'http://localhost:3001';
    // const shopUrl = process.env.NEXT_PUBLIC_BASE_SHOP_URL_ENDPOINT?.replace(/\/$/, '');
    // const finalSrc = isSslHttp ? src : `${shopUrl}/${src}`;
    //
    // // Validate image type
    // const allowedImageTypes = ['jpg', 'jpeg', 'png', 'gif'];
    // const url = new URL(finalSrc);
    // const extension = url.pathname.split('.').pop().toLowerCase();
    //
    // if (!allowedImageTypes.includes(extension)) {
    //   return src;
    // }
    //
    // return `${cdnUrl}/_next/image?url=${encodeURIComponent(finalSrc)}&w=${width}&q=${quality || 100}`;
}
